module.exports = __webpack_public_path__ + "img/BAND_LOGO_green.3d64412b.png";